module.exports = __webpack_public_path__ + "img/step3.290bea18.png";